export default __webpack_public_path__ + "static/media/1x.3ed4cdfc.svg";